import { createSlice } from '@reduxjs/toolkit'
import { setLoadedDone, setLoading } from '../reducers'
import { STATUS } from '../../enums/common'
import { initialDataFailed, initialDataReceived } from '../actions'

const loadingSlice = createSlice({
  name: 'loading',
  initialState: {
    status: STATUS.idle,
  },
  reducers: {
    loading: setLoading,
    loaded: setLoadedDone,
  },
  extraReducers: (builder) => {
    builder.addCase(initialDataReceived, setLoadedDone)
    builder.addCase(initialDataFailed, setLoadedDone)
    builder.addCase('jddAddress/addressLoading', setLoading)
    builder.addCase('jddAddress/addressReceived', setLoadedDone)
    builder.addCase('jddAddress/addressFailed', setLoadedDone)
  },
})

const { actions, reducer } = loadingSlice
export const loadingActions = actions

export default reducer
